import { Timestamp } from '../firebase';

export function formatTodoReminderDisplay(todo, t, i18n) {
  if (todo.done) return null;
  if (
    todo.reminderBeforeDeadlineMinutes != null &&
    Number.isFinite(todo.reminderBeforeDeadlineMinutes)
  ) {
    const m = todo.reminderBeforeDeadlineMinutes;
    if (m === 0) return t('reminderSummaryAtDeadline');
    return t('reminderSummaryNBeforeDeadline', { n: m });
  }
  const at = todo.nextReminderAt || todo.notifyAt;
  if (!at?.toDate) return null;
  return t('reminderSummaryAtTime', { time: at.toDate().toLocaleString(i18n.language) });
}

/**
 * Build Firestore fields for todo reminders (server scan uses nextReminderAt || notifyAt).
 * @param {object} opts
 * @param {import('firebase/firestore').Timestamp | null} opts.deadlineAt
 * @param {'none'|'at'|'before'} opts.reminderKind
 * @param {string} opts.notifyAtLocal datetime-local value
 * @param {number | null} opts.beforeDeadlineMinutes minutes before deadlineAt (0 = at deadline)
 */
export function buildTodoReminderFields({ deadlineAt, reminderKind, notifyAtLocal, beforeDeadlineMinutes }) {
  if (reminderKind === 'at' && notifyAtLocal?.trim()) {
    const ts = Timestamp.fromDate(new Date(notifyAtLocal.trim()));
    return {
      notifyAt: ts,
      nextReminderAt: ts,
      reminderBeforeDeadlineMinutes: null,
    };
  }

  if (
    reminderKind === 'before' &&
    deadlineAt &&
    beforeDeadlineMinutes != null &&
    Number.isFinite(beforeDeadlineMinutes) &&
    beforeDeadlineMinutes >= 0
  ) {
    const ms = deadlineAt.toMillis() - beforeDeadlineMinutes * 60000;
    return {
      notifyAt: null,
      nextReminderAt: Timestamp.fromMillis(ms),
      reminderBeforeDeadlineMinutes: beforeDeadlineMinutes,
    };
  }

  return {
    notifyAt: null,
    nextReminderAt: null,
    reminderBeforeDeadlineMinutes: null,
  };
}

/** Select `value` is minutes before (string); `custom` uses a separate numeric input. */
export const REMINDER_OFFSET_PRESETS = [
  { value: '0', labelKey: 'reminderOffsetAtDue' },
  { value: '5', labelKey: 'reminderOffset5m' },
  { value: '15', labelKey: 'reminderOffset15m' },
  { value: '30', labelKey: 'reminderOffset30m' },
  { value: '60', labelKey: 'reminderOffset1h' },
  { value: '120', labelKey: 'reminderOffset2h' },
  { value: '1440', labelKey: 'reminderOffset1d' },
  { value: 'custom', labelKey: 'reminderOffsetCustom' },
];

export const CALENDAR_REMINDER_OFFSET_PRESETS = [
  { value: '', labelKey: 'calendarReminderNone' },
  { value: '0', labelKey: 'reminderOffsetAtEvent' },
  { value: '5', labelKey: 'reminderOffset5m' },
  { value: '15', labelKey: 'reminderOffset15m' },
  { value: '30', labelKey: 'reminderOffset30m' },
  { value: '60', labelKey: 'reminderOffset1h' },
  { value: '120', labelKey: 'reminderOffset2h' },
  { value: '1440', labelKey: 'reminderOffset1d' },
  { value: 'custom', labelKey: 'reminderOffsetCustom' },
];
